/**
 * Resolve user-facing "Specific Details" from a saved design record.
 * Never return the full AI image-generation prompt.
 */

export function extractUserInstructionsFromPrompt(prompt) {
  if (!prompt?.trim()) return ''

  const specialMatch = prompt.match(
    /Special design instructions:\s*(.+?)(?:\.\s*(?:Photorealistic|Professional product|Create a highly)|$)/is
  )
  if (specialMatch?.[1]?.trim()) {
    return specialMatch[1].trim()
  }

  const importantMatch = prompt.match(
    /IMPORTANT:\s*The design features\s+(.+?)\.\s*Professional product photography/is
  )
  if (importantMatch?.[1]?.trim()) {
    return importantMatch[1].trim()
  }

  const sandwichMatch = prompt.match(
    /(?:premium craftsmanship|professional finish|well-made, good quality)\.\s*(.+?)\.\s*Professional product photography/is
  )
  if (sandwichMatch?.[1]?.trim()) {
    const chunk = sandwichMatch[1].trim()
    if (!/^IMPORTANT:\s*Show ONLY the clothing/i.test(chunk)) {
      return chunk.replace(/^IMPORTANT:\s*The design features\s+/i, '').trim()
    }
  }

  return ''
}

export function resolveSavedCustomInstructions(design) {
  if (!design) return ''

  if (design.customPrompt?.trim()) return design.customPrompt.trim()
  if (design.customInstructions?.trim()) return design.customInstructions.trim()

  const fromPrompt = extractUserInstructionsFromPrompt(design.prompt || '')
  if (fromPrompt) return fromPrompt

  // Last resort: if prompt doesn't look like server AI boilerplate, show it as-is
  const prompt = design.prompt?.trim() || ''
  if (!prompt) return ''
  const looksLikeAiPrompt =
    /High-end fashion photography|Professional product photography|clean white background, studio lighting|Show ONLY the clothing item/i.test(
      prompt
    )
  return looksLikeAiPrompt ? '' : prompt
}
